var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcAirportShuttleW(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 12.727,
    viewBox: "0 0 20 12.727",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134",
    transform: "translate(-12 -11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_8",
    "data-name": "Exclusion 8",
    className: "cls-1",
    d: "M1832.636-194.545h-12.727a1.818,1.818,0,0,0-1.818,1.818v8.182h1.818a2.729,2.729,0,0,0,2.727,2.727,2.729,2.729,0,0,0,2.727-2.727h5a2.729,2.729,0,0,0,2.727,2.727,2.729,2.729,0,0,0,2.727-2.727h2.273v-4.545Zm-10,11.364a1.362,1.362,0,0,1-1.364-1.364,1.362,1.362,0,0,1,1.364-1.364,1.362,1.362,0,0,1,1.364,1.364A1.362,1.362,0,0,1,1822.636-183.182Zm10.455,0a1.362,1.362,0,0,1-1.364-1.364,1.362,1.362,0,0,1,1.364-1.364,1.362,1.362,0,0,1,1.364,1.364A1.362,1.362,0,0,1,1833.091-183.182Zm-2.273-5.909v-3.636h.909l3.636,3.636Z",
    transform: "translate(-1806.091 205.545)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAirportShuttleW);
export default __webpack_public_path__ + "static/media/ic_airport_shuttle_w.14be7d2328c4a7e7b775ec695aef3d88.svg";
export { ForwardRef as ReactComponent };